import getURLSearchParam from '@zhenguo/jssdk/base/url'
import { genOtherActUrl } from '@zhenguo/jssdk/act-url'
import Agent from '@zhenguo/jssdk/agent'
import { SOURCE } from '@zhenguo/vue-jssdk/business/VerifyEduForm/utils'
import { md5 } from '@/utils/md5'

const phxFrom = getURLSearchParam('phx_from')
const requestId = getURLSearchParam('requestId')

export function getSource(theme) {
  if (requestId) return SOURCE.PARTTIME
  const configSource = theme.source
  if (configSource && [5, 6, 7, 8].indexOf(Number(configSource)) !== -1) {
    if (Number(configSource) === SOURCE.ICEBEAR) {
      const hasExtra = getURLSearchParam('extra')
      return hasExtra ? SOURCE.ICEBEAR : SOURCE.ACTIVITY
    }
    if (Number(configSource) === SOURCE.INMENG) {
      if (!Agent.weixin) {
        throw new Error('非正常访问')
      }
    }
    return Number(configSource)
  }
  const themeNative = getURLSearchParam('theme') === 'native'
  if (phxFrom) {
    return SOURCE.ACTIVITY
  } else if (themeNative) {
    return SOURCE.DEFAULT
  } else {
    return SOURCE.BD
  }
}

// 不同渠道会带一些特殊参数
export function getRedirectPage(url, userInfo, source) {
  const baseUrl = url || genOtherActUrl('edu')
  if (source === SOURCE.INMENG) {
    return (
      baseUrl + '?user_id=' + userInfo.userId + '&sign=' + md5('inmeng_meituan' + userInfo.userId + 'inmeng_meituan')
    )
  }
  if (source === SOURCE.ICEBEAR) {
    return baseUrl + '?uid=' + userInfo.mtUserId + '&extra=' + getURLSearchParam('extra')
  }
  return baseUrl
}
